import { clearRowCache } from "./apiRequests";

/**
 * Changes the deployment to use
 * @param {string} newDeployment
 */
export function setDeployment(newDeployment) {
    clearRowCache();
    newDeployment = newDeployment.trim();
    sessionStorage.setItem("deployment", newDeployment);
}

/**
 * Returns the deployment that is being used
 * @returns {string}
 */
export function getDeployment() {
    let deployment = sessionStorage.getItem("deployment");
    if (!deployment) {
        deployment =
            window.origin === "http://localhost:3000"
                ? "int"
                : window.location.hostname.split(".")[0];
        sessionStorage.setItem("deployment", deployment);
    }
    return deployment;
}

/**
 * Gets the URL for the API
 * @returns {string}
 */
export function getApiUrl() {
    return `https://api.${getDeployment()}.stationportal.nmp.nonprod-sinclairstoryline.com`;
}

/**
 * Gets the URL for the station logos
 * @returns {string}
 */
export function getLogoUrl() {
    return `https://logos.${getDeployment()}.stationportal.nmp.nonprod-sinclairstoryline.com`;
}
